import axios from "./config";

/**
 * Fetch all project onboarding records from API
 *
 * @function
 * @name getProjectOnboardingRecords
 * @param {Object} filter - Filter parameters including page
 * @returns {Promise}
 *
 * @version 0.1.0
 * @since 0.1.0
 */
const getProjectOnboardingRecords = (filter = {}) => {
    return axios.get(`/project-onboarding`, { params: filter }).then((response) => response.data);
};

/**
 * Retry a project onboarding process
 *
 * @function
 * @name retryProjectOnboarding
 * @param {Number} id - ID of the onboarding record to retry
 * @returns {Promise}
 *
 * @version 0.1.0
 * @since 0.1.0
 */
const retryProjectOnboarding = (id) => {
    return axios.post(`/project-onboarding/${id}/retry`).then((response) => response.data);
};

/**
 * Delete a project onboarding record
 *
 * @function
 * @name deleteProjectOnboarding
 * @param {Number} id - ID of the onboarding record to delete
 * @returns {Promise}
 *
 * @version 0.1.0
 * @since 0.1.0
 */
const deleteProjectOnboarding = (id) => {
    return axios.delete(`/project-onboarding/${id}`).then((response) => response.data);
};

/**
 * Download the onboarding Excel template (returns Blob)
 */
const downloadOnboardingTemplate = () => {
    return axios.get(`/project-onboarding/template`, { responseType: 'blob' });
};

const projectOnboardingAPI = {
    getProjectOnboardingRecords,
    retryProjectOnboarding,
    deleteProjectOnboarding,
    downloadOnboardingTemplate,
};

export default projectOnboardingAPI;